import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isContactsEmail(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.CONTACTS_EMAIL && typeof label === 'string' && typeof value === 'string';
}
function _formatContactsEmail(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatContactsEmail(submission) {
  if (isContactsEmail(submission)) {
    return _formatContactsEmail(submission);
  }
  return undefined;
}
//# sourceMappingURL=contacts-email-preview.js.map